import React, { useContext } from "react";

import { useCloudFileApi } from "../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { RecordType } from "../../../../../common/types/RecordType";
import { CloudFileQcDoneDialog } from "../../../common/components/qc-done/CloudFileQcDoneDialog";
import { CloudFileStatus } from "../../../common/types/CloudFileStatus";
import { CloudFileListingContext } from "../../CloudFileListingContext";

interface ChangeCloudFileToQcDoneListingDialogProps {
    onClose(): void;
    isOpen: boolean;
    cloudFileId: string;
    cloudFileRecordType: RecordType;
    fileRecordId?: string;
}

export const ChangeCloudFileToQcDoneListingDialog: React.VFC<ChangeCloudFileToQcDoneListingDialogProps> = ({
    cloudFileId,
    fileRecordId,
    cloudFileRecordType,
    isOpen,
    onClose
}: ChangeCloudFileToQcDoneListingDialogProps) => {
    const { validateCloudFileToQcDone } = useCloudFileApi();

    const { updateCloudFileStatus } = useContext(CloudFileListingContext);

    const handleConfirmation = async () => {
        updateCloudFileStatus(cloudFileId, CloudFileStatus.QcDone);
    };

    return (
        <CloudFileQcDoneDialog
            cloudFileRecordType={cloudFileRecordType}
            cloudFileId={cloudFileId}
            fileRecordId={fileRecordId}
            isOpen={isOpen}
            onClose={onClose}
            validate={validateCloudFileToQcDone}
            onHandleConfirmation={handleConfirmation}
            width={1200}
        />
    );
};
